import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isPhone, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        alignSelf: 'center',
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        width: isPhone ? '100%' : widthPercentageToDP(476),
        height: '100%',
    },
});

export default styles;
